import { z } from 'zod';

export type VariableType = 'NORMAL' | 'EMAIL_INBOX';

export const zVariableValidationType = z
  .string()
  .min(1, 'Variable name is required')
  .max(255, 'Variable name is too long (maximum 255 characters)')
  .regex(
    /^[a-zA-Z_][a-zA-Z0-9_]*$/,
    'Variable name must start with a letter or underscore, followed by letters, numbers, or underscores',
  );

export const zValidationResult = z.discriminatedUnion('isValid', [
  z.object({
    isValid: z.literal(true),
  }),
  z.object({
    isValid: z.literal(false),
    reason: z.string(),
    suggestedVariableName: z.string().optional(),
  }),
]);

export type ValidationResult = z.infer<typeof zValidationResult>;
